import { getByField } from "./commonRequests";

const ADMIN_PATH = "/admin";

export const isAdmin = (email) => {
  return getByField(ADMIN_PATH, email);
};
